import React, { Component } from 'react';
import './NetworkLogo.css';
import Utils from '../../../base/Utils';

class NetworkLogo extends Component {
    classes = {
        'instagram': 'Instagram',
        'facebook': 'Facebook',
        'twitter': 'Twitter',
        'linkedin': 'LinkedIn',
        'pinterest': 'Pinterest',
        'tumblr': 'Tumblr',
        'youtube': 'YouTube'
    };
    
    availableTypes = ['Icon', 'Name'];
    availableSizes = ['Big', 'Medium', 'Small'];
    
    render() {
        var network = this.props.network.toLowerCase();
        var type = Utils.checkAvailability(this.availableTypes, this.props.type, true);
        var size = Utils.checkAvailability(this.availableSizes, this.props.size, true);
        
        var classValue = "NetworkLogo " + size + " " + this.classes[network] + " " + type;
        
        var html = <i className={classValue}></i>;
        
        return html;
    }
}

export default NetworkLogo;
